import { AntragDtoModel } from '@ebeihilfe/core';
import { ApplicationsListState } from '../reducers/applications-list.reducer';
import { Injectable, Signal, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { applicationsListActions } from '../actions';
import { selectList, selectListError, selectListLoading } from '../selectors';

@Injectable()
export class ApplicationsListFacade {
  private readonly store: Store<ApplicationsListState> = inject(Store);

  public clearStore(): void {
    this.store.dispatch(applicationsListActions.clearStore());
  }

  public loadList(): void {
    this.store.dispatch(applicationsListActions.load());
  }

  public selectError(): Signal<Error> {
    return this.store.selectSignal(selectListError);
  }

  public selectList(): Observable<AntragDtoModel[]> {
    return this.store.select(selectList);
  }

  public selectLoading(): Signal<boolean> {
    return this.store.selectSignal(selectListLoading);
  }
}
